import { CITIES, TRADE_LOCAL_ANGLES } from "@/lib/site-data";

/**
 * Average Google Ads cost-per-click benchmarks for Utah trades.
 * Synthesized from public WordStream / LocaliQ / Google Keyword Planner
 * ranges (Q1 2026). Numbers are mid-range estimates — directional, not
 * guaranteed; refresh quarterly.
 */
export interface CpcRow {
  citySlug: string;
  cityName: string;
  region: string;
  /** Per-trade USD CPC. Keys match TradeLocalAngle.slug. */
  cpc: Record<string, number>;
}

// Base CPCs (USD) per trade — non-emergency residential service searches.
const BASE_CPC: Record<string, number> = {
  plumber: 11.5,
  electrician: 9.8,
  hvac: 13.4,
  roofer: 19.6,
};

// City multiplier (competition density). Lehi/Provo/Orem run hotter.
const CITY_MULT: Record<string, number> = {
  "lehi-ut": 1.18,
  "american-fork-ut": 1.04,
  "saratoga-springs-ut": 0.92,
  "pleasant-grove-ut": 0.96,
  "eagle-mountain-ut": 0.88,
  "orem-ut": 1.12,
  "provo-ut": 1.15,
};

export const CPC_TABLE: CpcRow[] = CITIES.map((c) => {
  const mult = CITY_MULT[c.slug] ?? 1;
  const cpc: Record<string, number> = {};
  for (const t of TRADE_LOCAL_ANGLES) {
    cpc[t.slug] = Number((BASE_CPC[t.slug] * mult).toFixed(2));
  }
  return {
    citySlug: c.slug,
    cityName: c.name,
    region: c.region,
    cpc,
  };
});

export const CPC_UPDATED_AT = "2026-01-15";
export const CPC_SOURCES = [
  "Google Ads Keyword Planner (Utah County geo, 90-day avg)",
  "WordStream Home Services Benchmark Report 2025",
  "LocaliQ Local Services Vertical Benchmarks Q4 2025",
] as const;